import { render, staticRenderFns } from "./PreviewVideos.vue?vue&type=template&id=c868aed8"
import script from "./PreviewVideos.vue?vue&type=script&lang=js"
export * from "./PreviewVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c868aed8')) {
      api.createRecord('c868aed8', component.options)
    } else {
      api.reload('c868aed8', component.options)
    }
    module.hot.accept("./PreviewVideos.vue?vue&type=template&id=c868aed8", function () {
      api.rerender('c868aed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/PreviewVideos.vue"
export default component.exports